(() => {
  // app/scripts/common/component/cartRemove.js
  var CartRemoveButton = class extends HTMLElement {
    connectedCallback() {
      const link = this.querySelector("a");
      link.addEventListener("click", (event) => {
        try {
          event.preventDefault();
          let { key, sections, sections_url } = link.dataset;
          if (!key)
            return;
          sections = [sections];
          this.closest("cart-component,cart-drawer-component").dispatchEvent(new CustomEvent("change", {
            bubbles: true,
            detail: {
              customElement: {
                target: link,
                key,
                quantity: 0,
                sections,
                sections_url
              }
            }
          }));
        } catch (e) {
          console.log(e);
        }
      });
    }
  };
  customElements.define("cart-remove-button", CartRemoveButton);

  // app/scripts/common/component/cartUpdateComponent.js
  !customElements.get("cart-update-component") && customElements.define("cart-update-component", class extends cartForm {
    constructor() {
      super();
      this.addEventListener("change", (e) => {
        this.currentTarget = e.target;
        let { value } = this.currentTarget;
        if (this.currentTarget.type == "checkbox") {
          value = this.currentTarget.checked;
        }
        this.onUpdate(value);
        if (this.querySelector(".jsValue"))
          this.querySelector(".jsValue").innerHTML = value;
      });
    }
    onUpdate(value) {
      const attributes = { [this.dataset.type]: value };
      this.disabled = true;
      this.cartUpdate(attributes);
    }
    set disabled(value) {
      this.classList.toggle("event-none", value);
    }
    async onFinished() {
      this.updateState();
      this.disabled = false;
    }
    async updateState() {
      const { sectionId } = this.dataset;
      if (!sectionId)
        return;
      let url = location.href;
      url += url.includes("?") ? "&" : "?";
      url += sectionId;
      let html = await fetch(url);
      html = await html.text();
      const div = document.createElement("div");
      div.innerHTML = html;
      this.closest("filter-component")?.render(div);
      if (this.currentTarget.closest("details[open]"))
        this.currentTarget.closest("details[open]").open = false;
    }
  });

  // app/scripts/cart-component.js
  var cartComponent = class extends cartForm {
    constructor() {
      super();
      this.addEventListener("change", this.onChange.bind(this));
    }
  };
  customElements.define("cart-component", cartComponent);
})();
